import axios, { AxiosResponse } from "axios";
import { BASE_URL } from "../config/api_collection";
import { getToken } from "../helper/token";
import { getHeaderData } from "./crm";
import { BOOKING_IS_ETIHAD_BOOKING } from "constants/variables";

const CHECK_GROUP_BOOKING_WITH_PNR = `${BASE_URL}/api/ibe/groupBooking/isGroupBooking`;
const CHECK_GROUP_BOOKING_WITHOUT_PNR = `${BASE_URL}/api/ibe/groupBooking/retrieveGroupBooking/phone`;
const GROUP_BOOKING_VALIDATION_PASSENGER = `${BASE_URL}/api/ibe/groupBooking/validateGroupBookingPassenger`;  //validatePerson

type bookingType = "myBooking" | "checkin";

interface CheckGroupBookingPnr {
  pnrDetails?: string; // Optional property for the record locator
  lastName?: string | null; // Allow null
  email?: string | null; // Allow null
  bookingType?: bookingType
}

interface CheckGroupBookingWithoutPnr {
  phone?: string; // Optional property for the record locator
  originStationCode?: string | null; // Allow null
  departureDate?: string | null; // Allow null
  destinationStatusCode?: string | null; // Allow null
  bookingType?: bookingType
}

export interface validationGroupBookingParams {
  firstName: string | null; // Optional property for the record locator
  lastName: string | null; // Allow null
}

export const checkGroupBooking = async (params: CheckGroupBookingPnr) => {
  try {
    const headers = await getToken(true);

    let url = `${CHECK_GROUP_BOOKING_WITH_PNR}?`;
    if (params?.pnrDetails) {
      url += `recordLocator=${params?.pnrDetails}`;
    }
    if (params?.lastName) {
      url += `&lastName=${params?.lastName}`;
    }
    if (params?.email) {
      url += `&emailAddress=${params?.email}`;
    }
    if (params?.bookingType) {
      url += `&type=${params?.bookingType}`;
    }
    const response = await axios.get( url, { headers } );
    return response.data.data;
  } catch (error: any) {
    if(error.response.data.error.status === "FORBIDDEN"){
      return BOOKING_IS_ETIHAD_BOOKING;
    } else{
      return false;
    }
  }
};

export const checkGroupBookingWithoutPNR = async (params: CheckGroupBookingWithoutPnr) => {
  try {
    const headers = await getToken(true);

    let url = `${CHECK_GROUP_BOOKING_WITHOUT_PNR}?`;
    if (params?.phone) {
      url += `phoneNumber=${params?.phone}`;
    }
    if (params?.originStationCode) {
      url += `&origin=${params?.originStationCode}`;
    }
    if (params?.departureDate) {
      url += `&departureDate=${params?.departureDate}`;
    }
    if (params?.destinationStatusCode) {
      url += `&destination=${params?.destinationStatusCode}`;
    }
    if (params?.bookingType) {
      url += `&type=${params?.bookingType}`;
    }
    const response = await axios.get(url, { headers });

    return response.data.data;
  } catch (error: any) {
    if (error.response.data.error.status === "FORBIDDEN") {
      return BOOKING_IS_ETIHAD_BOOKING;
    } else {
      return false;
    }
  }
};

export async function groupBookingValidationPassenger(params: validationGroupBookingParams) {
  try {
    const headers = await getHeaderData();
    const response = await axios.post(GROUP_BOOKING_VALIDATION_PASSENGER, params, { headers });

    return response.data.data; 
    // return validatePersonResponse;
  } catch (error: any) {
    return {
      status: false,
      errorMessage: error?.response?.data?.error?.message
    };
  }
}